<template>
  <div>
    <div class="pl-3 pr-3 pt-2">
      <h5>
        Missions <b-badge variant="primary">{{ sections_length }}</b-badge>
        <b-button variant="primary" class="p-2 btn-xs float-right" disabled>Create new mission</b-button>
      </h5>
    </div>
    <b-table-simple v-if="sections_length > 0" sticky-header hover small caption-top striped class="sections-table">
      <b-thead>
        <b-tr>
          <b-th class="pl-3 shadow-sm border-bottom-0">No.</b-th>
          <b-th class="shadow-sm border-bottom-0">Start</b-th>
          <b-th class="shadow-sm border-bottom-0">Duration</b-th>
          <b-th class="shadow-sm border-bottom-0" style="width: 200px;">Description</b-th>
          <b-th class="shadow-sm border-bottom-0">Status</b-th>
          <b-th class="shadow-sm border-bottom-0 text-center d-none d-xl-table-cell">Actions</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="section in filtered_sections" :key="section.section_id">
          <b-td class="pl-3"><strong>{{ section.mission_id }}</strong></b-td>
          <b-td>{{ getDate(section.timestamp_start) }}</b-td>
          <b-td class="text-right">{{ getDuration(section.timestamp_start, section.timestamp_end) }}</b-td>
          <b-td style="overflow-x: hidden">{{ section.description_short }}</b-td><!-- TODO: Shorten description if necessary -->
          <b-td><div v-html="getStatusBadge(section.status)"></div></b-td>
          <b-td class="text-center d-none d-xl-table-cell">
            <b-button disabled variant="secondary" class="btn-xs mr-1" title="Show mission in map">
              <font-awesome-icon :icon="['fas', 'eye']" size="xs" />
            </b-button>
            <b-button disabled variant="secondary" class="btn-xs mr-1" title="Open mission">
              <font-awesome-icon :icon="['fas', 'edit']" size="xs" />
            </b-button>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <div v-else class="pl-3 pr-3 pt-1">
      <b-alert show variant="info">No mission found</b-alert>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment-duration-format'
import { mapGetters, mapState } from 'vuex'
import Helpers from '@/mixins/helpers'

export default {
  name: 'AuvMissionWidget',
  props: [
    'platformId'
  ],
  mixins: [
    Helpers
  ],
  methods: {
    // ...mapMutations(['select_section']),
    compareSectionIds: function (section1, section2) {
      if (section1.section_id < section2.section_id) {
        return 1
      } else {
        return -1
      }
    },
    getAge: function (timestamp, skip) {
      if (timestamp > 0) {
        return moment.unix(timestamp).fromNow(skip)
      } else {
        return 'never'
      }
    },
    getDate: function (timestamp) {
      return moment.unix(timestamp).format('YY-MM-DD HH:mm')
    },
    getDuration: function (timestamp1, timestamp2) {
      const start = moment.unix(timestamp1)
      const end = moment.unix(timestamp2)
      const ms = end.diff(start)
      return moment.duration(ms, 'milliseconds').format()
    },
    getStatusBadge: function (status) {
      switch (status) {
        case 1:
          return '<span class="badge badge-primary">Created</span>'
        case 2:
          return '<span class="badge badge-info">Downloaded</span>'
        case 3:
          return '<span class="badge badge-info">Exported</span>'
        case 4:
          return '<span class="badge badge-info">Saved</span>'
        case 5:
          return '<span class="badge badge-success">Completed</span>'
        default:
          return '<span class="badge badge-warning">Unknown</span>'
      }
    }
  },
  created: function () {
    // Configure moment
    moment.relativeTimeThreshold('ss', -1)
  },
  mounted: function () {
    // Initialize last change timestamp
    // this.updateLastUpdate()
  },
  beforeDestroy: function () {
  },
  computed: {
    ...mapState(['selectedCampaign']),
    ...mapGetters(['sections']),
    sections_length: function () {
      return Object.keys(this.filtered_sections).length
    },
    filtered_sections: function () {
      const filteredSections = []
      const sections = this.sections(this.platformId)
      for (const sectionId in sections) {
        if (sections[sectionId].campaign_id === this.selectedCampaign) {
          filteredSections.push(sections[sectionId])
        }
      }
      return filteredSections.sort(this.compareSectionIds)
    }
    // parameter_selected: function () {
    //   return (parameterId) => {
    //     // Compare every element as comparing of arrays is difficult
    //     if (this.selectedParameter !== null) {
    //       if (this.selectedParameter[0] === this.platformId &&
    //         this.selectedParameter[1] === this.entityId &&
    //         this.selectedParameter[2] === parameterId) {
    //         return 'primary'
    //       }
    //       if (this.selectedParameterCompare !== null) {
    //         if (this.selectedParameterCompare[0] === this.platformId &&
    //           this.selectedParameterCompare[1] === this.entityId &&
    //           this.selectedParameterCompare[2] === parameterId) {
    //           return 'info'
    //         }
    //       }
    //     }
    //     return 'default'
    //   }
    // },
    // parameter_ids: function () {
    //   return (parameterId) => {
    //     return [Number(this.platformId), Number(this.entityId), Number(parameterId)]
    //   }
    // },
    // parameter_value: function () {
    //   return (parameterId) => {
    //     // Note: Field precision was renamed due to MariaDB field restrictions (precision is reserved keyword)
    //     const parameter = this.parameter(this.platformId, this.entityId, parameterId)
    //     if (parameter.current.length !== 0) {
    //       if (Number(parameter.num_precision) > 0 && parameter.type === 'float') {
    //         return this.showDigits(this.roundDigits(parameter.current[1],
    //           parameter.num_precision), parameter.num_precision)
    //       }
    //       return parameter.current[1]
    //     }
    //     return 'n/a'
    //   }
    // },
    // parameter_lastupdate: function () {
    //   return (parameterId) => {
    //     const parameter = this.parameter(this.platformId, this.entityId, parameterId)
    //     if (parameter.current.length !== 0) {
    //       return Number(parameter.current[0] / 1000)
    //     }
    //     return -1
    //   }
    // },
    // parameter_valid: function () {
    //   return (parameterId) => {
    //     const lastUpdate = this.parameter_lastupdate(parameterId)
    //     const parameter = this.parameter(this.platformId, this.entityId, parameterId)
    //     return lastUpdate > 0 && (parameter.timeout === 0 || (parameter.timeout > 0 && (Date.now() / 1000) - lastUpdate < parameter.timeout))
    //   }
    // },
    // parameter_muted_class: function () {
    //   return (timestamp) => {
    //     return ((Date.now() / 1000) - timestamp > VALUE_MUTED_TIMEOUT) ? 'text-muted' : ''
    //   }
    // },
    // parameter_lastupdate_date: function () {
    //   return (parameterId) => {
    //     const lastupdate = this.parameter_lastupdate(parameterId)
    //     if (lastupdate > 0) {
    //       return moment.unix(this.parameter_lastupdate(parameterId)).format('MMMM DD YYYY HH:mm')
    //     }
    //     return 'No data available'
    //   }
    // }
  }
}

</script>

<style scoped>

.sections-table {
  margin-bottom: 0;
  max-height: 600px;
  width: 100%;
}

tr > th {
  border-top: 0;
}

</style>
